"use client"
import React from "react";
import ReactPlayer from "react-player";
import { useConfig } from "@/lib/providers/ConfigProvider";
import PropTypes from "prop-types";
import "@/components/shared/UralityVideo.css";

const UralityVideo = ({ asset, autoPlay }) => {
  const { apiUrl } = useConfig();
  const videoId = asset && asset.id;
  let previewUrl = apiUrl + "/api/files/" + videoId + ".jpg";
  let videoUrl = apiUrl + "/api/files/" + videoId + ".mp4";

  return (
    <div className="urality-video-wrapper">
      <ReactPlayer
        className="react-player"
        playsinline
        light={previewUrl}
        width={"100%"}
        height={"100%"}
        controls={true}
        url={videoUrl}
        playing={autoPlay}
      />
    </div>
  );
};
UralityVideo.propTypes = {
  asset: PropTypes.object
};
export default UralityVideo;
